import Vue from "vue";
import Vuex from "vuex";
import cards from "../../models/tarjetas/cards";
import employeedCard from "../../models/tarjetas/employeedCard";
import service from "../../services/tarjetas/cards";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "10px",
    cards: [],
    totalCards: 0,
    limit: 80, // Elementos por página
    offset: 0, // Posición inicial
    where: null,
    currentPage: 1,
    cardId: null,
    open: false,
    openEmployeed: false,
    mode: "Agregar tarjetas",
    modeEmployeed: "",
    new: {},
    newEmployeed: {},
    edit: {},
    employees: [],
    editEmployeed: {},
    itemDelete: null,
    openDelete: false,
    openDeleteEmployeed: false,
    selectedFilter: null,
    filterValue: "",
  },

  mutations: {
    setLimit(state, data) {
      state.limit = data;
    },
    setWhere(state, data) {
      state.where = data;
    },
    setFilterValue(state, data) {
      state.filterValue = data;
    },
    setSelectedFilter(state, data) {
      state.selectedFilter = data;
    },
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setCards(state, data) {
      state.cards = data.items;
      state.totalCards = data.total;
    },
    setOffset(state, offset) {
      state.offset = offset;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setEmployees(state, data) {
      state.employees = data;
    },
    setOpenEmployeed(state, data) {
      state.openEmployeed = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setModeEmployeed(state, data) {
      state.modeEmployeed = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setNewEmployeed(state, data) {
      state.newEmployeed = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setEmployeed(state, data) {
      state.edit.Employees = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setEditEmployeed(state, data) {
      state.editEmployeed = data;
    },
    setOpenDeleteEmployeed(state, data) {
      state.openDeleteEmployeed = data;
    },
  },
  actions: {
    updateWhere({ commit, dispatch }, where) {
      return new Promise((resolve) => {
        Promise.all([
          commit("setWhere", where),
          commit("setOffset", 0),
          commit("setCurrentPage", 1),
        ]).then(() => {
          dispatch("getCardsPaginate").then(() => {
            resolve(true);
          });
        });
      });
    },

    async getCardsPaginate({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const hasFilters = state.where !== null;
          const options = {
            limit: hasFilters ? undefined : state.limit,
            offset: hasFilters ? undefined : state.offset,
            where: state.where,
          };
          const items = await state.service.getCards(options);
          commit("setCards", items);
          resolve(true);
        } catch (error) {
          console.error("Error en getCardsPaginate:", error);
          reject(error);
        }
      });
    },

    async getCards({ state, commit }) {
      try {
        const result = await state.service.getCards({
          limit: state.limit,
          offset: state.offset,
        });
        commit("setCards", result);
      } catch (error) {
        console.error("Error fetching cards:", error);
      }
    },

    updatePage({ commit, dispatch, state }, page) {
      return new Promise((resolve) => {
        const newOffset = (page - 1) * state.limit;
        commit("setOffset", newOffset);
        commit("setCurrentPage", page);
        dispatch("getCards").then(() => {
          resolve(true); // Resuelve la promesa una vez que se complete el dispatch
        });
      });
    },

    async getCardData({ state, commit }, id) {
      try {
        const cardData = await state.service.getCardId(id);
        let cardResponse = cards.fromJson(cardData);
        commit("setEdit", cardResponse);

        let employeedData;
        try {
          const employesData = await state.service.getEmployeedCardId(id);
          employeedData = employesData.map((employeed) =>
            employeedCard.fromJson(employeed)
          );
        } catch (error) {
          employeedData = [];
        }
        commit("setEmployeed", employeedData);

        return true;
      } catch (error) {
        throw error;
      }
    },

    async addCards(state) {
      try {
        await state.state.service.addCards(state.state.new).then(async () => {
          await state.dispatch("getCards");
        });
        return true;
      } catch (error) {
        return false;
      }
    },

    async deleteCard(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteCard(state.state.itemDelete)
            .then(async () => {
              await state.dispatch("getCards");
            });
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async editCard(state) {
      try {
        const response = await state.state.service.editCard(state.state.edit);
        if (response.status === 204) {
          await state.dispatch("getCards");
          return true;
        } else {
          return false;
        }
      } catch (error) {
        throw error;
      }
    },

    async getEmployeed(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const operId = localStorage.getItem("operId");
          let items = await state.state.service.getEmployees(operId);
          state.commit("setEmployees", items);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async editEmployeedItem(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = state.state.editEmployeed;
          item.tarjId = state.state.edit.id;
          await state.state.service.editEmployeedCard(item).then(() => {
            let itemEmp = {};
            itemEmp.empId = item.empId;
            itemEmp.empNombre = item.empNombre;

            if (item.hasOwnProperty("fecDesdeNew")) {
              itemEmp.fecDesde = moment(item.fecDesdeNew, "YYYY-MM-DD").format(
                "DD-MM-YYYY"
              );
            } else {
              itemEmp.fecDesde = moment(item.fecDesde, "YYYY-MM-DD").format(
                "DD-MM-YYYY"
              );
            }

            if (item.hasOwnProperty("haNoEx")) {
              itemEmp.fecHasta = "";
            } else {
              if (item.hasOwnProperty("fecHastaNew")) {
                itemEmp.fecHasta = moment(
                  item.fecHastaNew,
                  "YYYY-MM-DD"
                ).format("DD-MM-YYYY");
              } else {
                itemEmp.fecHasta = moment(item.fecHasta, "YYYY-MM-DD").format(
                  "DD-MM-YYYY"
                );
              }
            }
            let options = state.state.edit.Employees;
            options = options.map((option) => {
              if (option.empId !== itemEmp.empId) {
                return option;
              }
              return itemEmp;
            });
            let edit = { ...state.state.edit };
            edit.Employees = options;
            state.commit("setEdit", edit);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    newEmployeed(state) {
      return new Promise((resolve, reject) => {
        state.state.service
          .addEmployeedCard(state.state.newEmployeed)
          .then(() => {
            let dataEmployeed = state.state.newEmployeed;
            dataEmployeed.empId = Number(dataEmployeed.empId);
            const emp = state.state.employees.find(
              (emp) => emp.empId === dataEmployeed.empId
            );
            if (!emp) {
              reject(new Error("Empleado no encontrado"));
              return;
            }
            const formattedNewEmployeed = {
              empId: emp.empId,
              empNombre: emp.name,
              fecDesde: moment(dataEmployeed.fecDesde).format("DD-MM-YYYY"),
              fecHasta: dataEmployeed.fecHasta
                ? moment(dataEmployeed.fecHasta).format("DD-MM-YYYY")
                : "",
            };
            const updatedEdit = {
              ...state.state.edit,
              Employees: [...state.state.edit.Employees, formattedNewEmployeed],
            };
            state.commit("setEdit", updatedEdit);
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async deleteEmployeed(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = state.state.itemDelete;
          item.tarjId = state.state.edit.id;
          await state.state.service.deleteEmployeedToCard(item).then(() => {
            let options = state.state.edit.Employees;
            options = options.filter((option) => {
              return option.empId != item.empId;
            });
            let edit = { ...state.state.edit };
            edit.Employees = options;
            state.commit("setEdit", edit);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  getters: {
    totalPages(state) {
      return Math.ceil(state.totalCards / state.limit);
    },
  },
});
